
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinnarayangaon() {



    const cardData =
    {
        keyword: 'Cab Service in Narayangaon',
        heading: 'Platinum24 Cabs: Cab Service in Narayangaon',
        headingDescription: ' Platinum24 Cabs provides reliable Cab Service in Narayangaon, catering to pilgrims, tourists, professionals, and local commuters. Whether you need a quick city ride, an airport transfer, or an outstation trip to Pune, Mumbai, or Nashik, our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures a safe and comfortable journey. With professional drivers, timely pickups, and transparent fares, we make every ride stress-free. From visiting nearby vineyards and tourist attractions to daily travel needs, Platinum24 Cabs guarantees affordability, reliability, and complete customer satisfaction across Narayangaon and surrounding areas.',

        top: 'Top Places to Visit in Narayangaon with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Junnar Caves",
    "description": "The Junnar Caves near Narayangaon are an ancient complex of over 200 rock-cut caves dating back to the 2nd century BCE. These caves reflect Buddhist architecture with chaityas, viharas, and intricate carvings. The Lenyadri Caves, one of the Ashtavinayak shrines, are also part of this cluster. Surrounded by hills, the site is both spiritual and historic. Trekkers and pilgrims find it equally fascinating. Junnar Caves are Narayangaon’s heritage gem."
  },
  {
    "title": "Lenyadri Ganpati Temple",
    "description": "Lenyadri Ganpati Temple, carved into a mountain cave, is one of the Ashtavinayak Ganpati shrines. Devotees climb 283 steps to reach the temple, making the journey both spiritual and adventurous. The idol of Lord Ganesha here is unique and naturally formed. The temple offers stunning views of the valley. During Ganesh festivals, thousands of pilgrims gather here. Lenyadri is Narayangaon’s sacred pilgrimage highlight."
  },
  {
    "title": "Shivneri Fort",
    "description": "Shivneri Fort, the birthplace of Chhatrapati Shivaji Maharaj, is a historical attraction near Narayangaon. Visitors climb pathways to explore bastions, water tanks, and the temple of Goddess Shivai. The fort has a statue of young Shivaji that inspires pride in Maratha history. Trekking here is popular, especially during monsoon. Panoramic Sahyadri views enrich the experience. Shivneri is Narayangaon’s proud heritage landmark."
  },
  {
    "title": "Narayangaon Vineyards",
    "description": "Narayangaon is known as Maharashtra’s wine country, home to several vineyards and wineries. Visitors enjoy vineyard tours, grape harvesting experiences, and wine tasting sessions. Popular brands like Chateau Indage started here, giving Narayangaon global recognition. The region’s pleasant climate enhances wine production. Tourists pair wine tours with scenic countryside drives. Vineyards make Narayangaon Maharashtra’s wine capital."
  },
  {
    "title": "Manmodi Caves",
    "description": "The Manmodi Caves, near Junnar, are a group of Buddhist caves carved into rocky cliffs. They feature chaityas, stupas, and viharas dating back to the Satavahana period. The carvings and inscriptions reflect early Buddhist culture. Surrounded by greenery, the caves are peaceful and less crowded. History lovers enjoy exploring their architectural details. Manmodi is Narayangaon’s hidden archaeological treasure."
  },
  {
    "title": "Harishchandragad Trek",
    "description": "Harishchandragad, a historic hill fort near Narayangaon, is one of Maharashtra’s most loved trekking destinations. The fort is famous for Konkan Kada, a cliff offering breathtaking valley views. Ancient caves, temples, and cisterns enrich its heritage appeal. The trek is challenging but rewarding with scenic trails. Monsoon adds waterfalls and misty landscapes. Harishchandragad is Narayangaon’s ultimate adventure escape."
  },
  {
    "title": "Pimpri Wildlife Sanctuary",
    "description": "Located near Narayangaon, Pimpri Wildlife Sanctuary is a green haven for flora and fauna. It is home to deer, wild boar, leopards, and a wide range of birds. Nature walks and safaris offer close encounters with wildlife. Dense forests and seasonal streams make it picturesque. Birdwatchers find it especially rewarding. Pimpri is Narayangaon’s natural retreat for eco-tourism."
  },
  {
    "title": "Vigneshwara Temple, Ozar",
    "description": "Ozar, near Narayangaon, is home to the Vigneshwara Temple, one of the Ashtavinayak shrines of Lord Ganesha. The temple’s golden dome, deep stambh, and stone carvings attract thousands of pilgrims. Festivals like Ganesh Chaturthi and Karthik Purnima are celebrated with devotion. Surrounded by peaceful countryside, it is ideal for a spiritual retreat. Ozar is Narayangaon’s divine heritage highlight."
  },
  {
    "title": "Yedgaon Dam",
    "description": "Yedgaon Dam on the Kukadi River is a popular picnic spot near Narayangaon. It provides irrigation to the region while offering scenic backwaters. Families enjoy day trips here with views of surrounding hills. Monsoon makes the dam’s overflow mesmerizing. Photographers capture its beauty during sunrise and sunset. Yedgaon is Narayangaon’s relaxing natural getaway."
  },
  {
    "title": "Local Markets & Grapes Festival",
    "description": "Narayangaon’s local markets are vibrant with fresh produce, handicrafts, and regional delicacies. The town is especially famous for grapes and organizes grape festivals during harvest season. Visitors enjoy grape-picking, tasting, and cultural programs. Local cuisine like bhakri-pithla and spicy curries adds flavor. Shopping for local wines and fruits is popular. Narayangaon’s markets celebrate culture, food, and farming traditions."
  }
],


     "services": [
    {
      "name": "Narayangaon Cab Service",
      "description": "Our Narayangaon Cab Service offers dependable, safe, and comfortable transportation options for both locals and visitors. Whether you're heading to nearby farms, wineries, markets, or traveling to other parts of Pune district, our cabs are readily available. We provide a variety of vehicle types including hatchbacks, sedans, and SUVs — all maintained to the highest standards. Book instantly for personal, family, or professional travel. With courteous drivers and 24x7 availability, we ensure every ride in Narayangaon is smooth, affordable, and stress-free."
    },
    {
      "name": "Taxi Service Narayangaon",
      "description": "Taxi Service Narayangaon is your reliable solution for point-to-point local travel, daily commuting, and outstation journeys. Our taxis are driven by experienced, locally knowledgeable drivers who prioritize punctuality and safety. Whether you're traveling for work, errands, or leisure, we offer fixed pricing, fast booking, and flexible payment options. Perfect for individuals, families, or business professionals looking for a no-hassle transport option."
    },
    {
      "name": "Narayangaon Local Taxi",
      "description": "Our Narayangaon Local Taxi service is perfect for intra-city movement — from the town center to surrounding villages, farms, vineyards, and residential colonies. With well-maintained vehicles and prompt pickups, we make sure your short-distance travel is both quick and comfortable. Whether it's a quick grocery trip or a visit to the local mandir, our taxis are available on demand with affordable hourly packages too."
    },
    {
      "name": "Affordable Taxi Narayangaon",
      "description": "If you’re looking for pocket-friendly travel, our Affordable Taxi Narayangaon service is the ideal solution. Get low-cost rides without compromising on safety or comfort. Perfect for students, daily workers, or budget travelers, this service offers clean, fuel-efficient vehicles and honest pricing with no hidden costs. Book for local or outstation trips and travel smart while staying within your budget."
    },
    {
      "name": "Narayangaon Taxi with Driver",
      "description": "Enjoy chauffeur-driven comfort with our Narayangaon Taxi with Driver service. Our drivers are polite, well-trained, and familiar with all the routes in and around Narayangaon. Whether you need a full-day driver for a wedding, a farm visit, or a winery tour, we offer clean vehicles and hassle-free service. Ideal for those who want to sit back and relax while a professional handles the road."
    },
    {
      "name": "Narayangaon Airport Taxi",
      "description": "Need airport transfers? Our Narayangaon Airport Taxi service offers safe and timely rides to and from Pune and Mumbai airports. Whether you have an early morning flight or a late-night arrival, our taxis are available 24x7. With comfortable cars, ample luggage space, and live flight tracking for timely pickups and drop-offs, we ensure a stress-free airport travel experience."
    },
    {
      "name": "Cab Rental Narayangaon",
      "description": "With Cab Rental Narayangaon, you get flexible travel options for all occasions. Choose from half-day, full-day, or multi-day rentals with or without a driver. Ideal for events, sightseeing, outstation visits, and business trips — our fleet is ready to serve you. Transparent billing, clean vehicles, and dependable service make us the go-to choice for rentals in Narayangaon and nearby areas."
    },
    {
      "name": "Narayangaon Outstation Taxi",
      "description": "Travel from Narayangaon to popular destinations like Pune, Mumbai, Nashik, Shirdi, and more with our Narayangaon Outstation Taxi service. We offer both one-way and round-trip packages with experienced drivers who ensure a safe and enjoyable journey. Our taxis are perfect for weekend getaways, pilgrimages, and business travel, with pre-quoted fares, comfort-focused vehicles, and round-the-clock support."
    },
    {
      "name": "Narayangaon Corporate Taxi",
      "description": "Our Narayangaon Corporate Taxi service is tailored for companies, offices, and professionals needing reliable transport solutions. From employee transfers to guest pickups, we offer timely, clean, and professional taxi services. Get the benefits of GST billing, monthly invoicing, priority bookings, and premium vehicle options — all designed to support your organization’s mobility needs."
    },
    {
      "name": "Narayangaon Taxi Deals",
      "description": "Get the best value with our Narayangaon Taxi Deals. Whether it’s an early booking, round-trip plan, or a weekend special, we provide seasonal discounts and promo offers to help you save. Check our website or app for ongoing deals and unlock affordable pricing on everything from short local trips to long-distance rides. Perfect for frequent travelers and regular commuters."
    },
    {
      "name": "Narayangaon Family Taxi Service",
      "description": "Planning a family outing, temple visit, or wedding event? Our Narayangaon Family Taxi Service provides spacious and clean vehicles with features like rear AC, booster seats (on request), and extra luggage space. Our drivers are patient, professional, and respectful — making your family trips safer and more enjoyable. Ideal for groups of all sizes traveling together comfortably."
    },
    {
      "name": "Taxi Booking Online Narayangaon",
      "description": "Easily book a taxi from the comfort of your phone or computer with Taxi Booking Online Narayangaon. Our user-friendly platform allows you to select the car type, schedule your ride, pay online, and track the driver in real-time. Bookings are instant and secure, with 24x7 customer support in case of changes or queries. Enjoy hassle-free, tech-enabled taxi service at your fingertips."
    },
    {
      "name": "Narayangaon Taxi Service 24x7",
      "description": "No matter the time or situation, our Narayangaon Taxi Service 24x7 is always ready to serve. Whether it’s a medical emergency, late-night arrival, early morning temple visit, or spontaneous road trip, we provide prompt and safe taxis any time of day. Our drivers are trained for night travel, and our support team is always on standby to assist you. Count on us for round-the-clock transportation in and around Narayangaon."
    }
  ],
  "tableData": [
    ["Narayangaon Cab Service", "Taxi Service Narayangaon"],
    ["Narayangaon Local Taxi", "Affordable Taxi Narayangaon"],
    ["Narayangaon Taxi with Driver", "Narayangaon Airport Taxi"],
    ["Cab Rental Narayangaon", "Narayangaon Outstation Taxi"],
    ["Narayangaon Corporate Taxi", "Narayangaon Taxi Deals"],
    ["Narayangaon Family Taxi Service", "Taxi Booking Online Narayangaon"],
    ["Narayangaon Taxi Service 24x7", "—"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service in Narayangaon",
    "WhyChoosedescription": "Platinum24 Cabs offers dependable and affordable cab services in Narayangaon for all your local and outstation travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicles to Suit Your Travel",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, and tempo travellers based on your group size and preferences."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Vehicles for Your Safety",
    "WhyChoosedescription": "All vehicles are regularly cleaned and sanitized to provide a safe and comfortable ride in Narayangaon."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Narayangaon Routes",
    "WhyChoosedescription": "Our professional drivers know the best routes around Narayangaon to ensure smooth and timely travel."
  },
  {
    "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
    "WhyChoosedescription": "Transparent fares inclusive of fuel, tolls, and driver allowances for a hassle-free experience."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our customer service team is available round the clock to assist with your Narayangaon cab bookings."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages for Short and Long Term",
    "WhyChoosedescription": "Select from hourly, daily, or long-term rental plans tailored to your travel needs."
  },
  {
    "WhyChooseheading": "Easy Online Booking with Instant Confirmation",
    "WhyChoosedescription": "Book your Narayangaon cab quickly and securely through our website or app with real-time confirmation."
  }
]




















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Narayangaon?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable cab services in Narayangaon for local and outstation travel.',
    },
    {
        question: 'How can I book a cab service in Narayangaon with Platinum24 Cabs?',
        answer: 'You can easily book a cab through our website, mobile app, or by contacting our 24x7 customer support.',
    },
    {
        question: 'What types of vehicles are available for cab service in Narayangaon?',
        answer: 'We offer hatchbacks, sedans, SUVs, and luxury cars to meet your travel needs in Narayangaon.',
    },
    {
        question: 'Can I use the cab service in Narayangaon for both local and outstation trips?',
        answer: 'Yes, Platinum24 Cabs provides cab services for local travel within Narayangaon as well as outstation journeys.',
    },
    {
        question: 'Are the drivers experienced and familiar with Narayangaon routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and well-versed with the routes in and around Narayangaon.',
    },
    {
        question: 'Is hourly and daily cab service available in Narayangaon?',
        answer: 'Yes, we offer flexible hourly and daily cab rental packages tailored to your travel plans.',
    },
    {
        question: 'Are the cabs sanitized and safe for passengers in Narayangaon?',
        answer: 'Yes, all vehicles are regularly sanitized, and drivers follow strict safety and hygiene protocols.',
    },
    {
        question: 'Is cab service in Narayangaon available 24x7?',
        answer: 'Yes, Platinum24 Cabs provides 24x7 cab booking and services in Narayangaon.',
    },
    {
        question: 'What payment options are accepted for cab bookings in Narayangaon?',
        answer: 'We accept cash, digital wallets, UPI, and card payments for smooth and secure transactions.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Narayangaon?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points within Narayangaon as per your travel needs.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajay Kulkarni',
        feedback: 'Excellent cab service in Narayangaon by Platinum24 Cabs. The driver was punctual and courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Meera Patil',
        feedback: 'Smooth and comfortable ride with Platinum24 Cabs in Narayangaon. Highly recommended.',
        rating: 5,
    },
];












































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];





const narayangaonCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Narayangaon offering local taxis, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver, available 24x7.",
  "areaServed": {
    "@type": "Place",
    "name": "Narayangaon, Pune"
  },
  "serviceType": [
    "Narayangaon Cab Service",
    "Taxi Service Narayangaon",
    "Narayangaon Local Taxi",
    "Affordable Taxi Narayangaon",
    "Narayangaon Taxi with Driver",
    "Narayangaon Airport Taxi",
    "Cab Rental Narayangaon",
    "Narayangaon Outstation Taxi",
    "Narayangaon Corporate Taxi",
    "Narayangaon Taxi Deals",
    "Narayangaon Family Taxi Service",
    "Taxi Booking Online Narayangaon",
    "Narayangaon Taxi Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};









    return (
        <div>
<Helmet>
  <title>Cab Service in Narayangaon | Affordable Taxi Service Narayangaon Pune</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Narayangaon offering local taxis, airport transfers, outstation cabs, corporate taxi, and family taxi services with driver, available 24x7."
  />
  <meta
    name="keywords"
    content="Narayangaon Cab Service, Taxi Service Narayangaon, Narayangaon Local Taxi, Affordable Taxi Narayangaon, Narayangaon Taxi with Driver, Narayangaon Airport Taxi, Cab Rental Narayangaon, Narayangaon Outstation Taxi, Narayangaon Corporate Taxi, Narayangaon Taxi Deals, Narayangaon Family Taxi Service, Taxi Booking Online Narayangaon, Narayangaon Taxi Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(narayangaonCabServiceSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/93.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinnarayangaon;